import { render } from "./NewsLists.vue?vue&type=template&id=66f6fe13&scoped=true&ts=true"
import script from "./NewsLists.vue?vue&type=script&lang=ts"
export * from "./NewsLists.vue?vue&type=script&lang=ts"

import "./NewsLists.vue?vue&type=style&index=0&id=66f6fe13&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f6fe13"]])

export default __exports__